module.exports = __webpack_public_path__ + "static/contact-hero-22554942bb89587e43456d33b839b158.svg";